import { render, staticRenderFns } from "./BSTableNew.vue?vue&type=template&id=5c1bdbb1&scoped=true"
import script from "./BSTableNew.vue?vue&type=script&lang=js"
export * from "./BSTableNew.vue?vue&type=script&lang=js"
import style0 from "./BSTableNew.vue?vue&type=style&index=0&id=5c1bdbb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1bdbb1",
  null
  
)

export default component.exports